import React from 'react';
import * as PropTypes from 'prop-types';
import InputBase from '@material-ui/core/InputBase/InputBase';
import Checkbox from 'UI/checkbox';
import PaginatedTable from 'components/dashboard/paginatedTable';
import Button from 'UI/button';
import Footer from 'UI/footer';

const SelectTemplate = ({
  classes,
  itineraryTemplateSearchValue,
  allPlaces,
  limit,
  isFetchingSuggestions,
  suggestions,
  templateItineraryId,
  errorMsg,
  isLoading,
  onSearchValueChange,
  onToggleAllPlaces,
  onHandleClick,
  onHandlePageChange,
  onSubmitHandler,
}) => {
  return (
    <div className={classes.body} style={{ width: '100%', margin: '5px', padding: '5px 20px' }}>
      <div className={classes.row} style={{ width: '100%', margin: '5px 5px' }}>
        <InputBase
          className={classes.itineraryTemplateInput}
          onChange={(e) => onSearchValueChange(e.target.value)}
          placeholder="filter results by id, title, destination, duration, CP"
          style={{ width: '80%', margin: '5px 10px' }}
        />
        <div className={classes.checkboxContainer}>
          <Checkbox
            color="primary"
            checked={allPlaces}
            label="All Places"
            onChange={onToggleAllPlaces}
          />
        </div>
      </div>
      <PaginatedTable
        pageSize={limit}
        loading={isFetchingSuggestions}
        suggestions={suggestions}
        templateItineraryId={templateItineraryId}
        handleClick={onHandleClick}
        handlePageChange={onHandlePageChange}
      />
      <br />
      <Footer errorMsg={errorMsg} extraClass={classes.spaceBetween}>
        <Button
          variant="outlined"
          loading={isLoading}
          onClick={() => {
            window.localStorage.setItem('shouldCallChatAgent', 'false');
            onSubmitHandler({ ignoreTemplate: true });
          }}
        >Create from Scratch
        </Button>
        <Button
          disabled={templateItineraryId === null}
          loading={isLoading}
          onClick={() => {
            window.localStorage.setItem('shouldCallChatAgent', 'false');
            onSubmitHandler({ ignoreTemplate: false });
          }}
        >Copy & Create
        </Button>
      </Footer>
    </div>
  );
};

SelectTemplate.propTypes = {
  classes: PropTypes.object.isRequired,
  itineraryTemplateSearchValue: PropTypes.string,
  allPlaces: PropTypes.bool.isRequired,
  limit: PropTypes.number.isRequired,
  isFetchingSuggestions: PropTypes.bool.isRequired,
  suggestions: PropTypes.array.isRequired,
  templateItineraryId: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  errorMsg: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  onSearchValueChange: PropTypes.func.isRequired,
  onToggleAllPlaces: PropTypes.func.isRequired,
  onHandleClick: PropTypes.func.isRequired,
  onHandlePageChange: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
};

export default SelectTemplate;
